import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-list-cell-renderer',
  templateUrl: './ag-list-cell-renderer.component.html',
  styleUrls: ['./ag-list-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgListCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  listItems: any;
  propertyToDisplay: string | null = null; // Default to null for strings

  agInit(params: any): void {
    this.params = params;

    // Check if a property name is defined for objects
    this.propertyToDisplay = params.propertyToDisplay || null;

    // Extract list items based on provided listName
    this.listItems = params.data[params.listName] || [];
  }

  refresh(params: any): boolean {
    this.params = params;

    // Check if a property name is defined for objects
    this.propertyToDisplay = params.propertyToDisplay || null;

    // Extract list items based on provided listName
    this.listItems = params.data[params.listName] || [];
    return true;
  }
}
